import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import type { SubscriberLead, SubscriberLeadSource } from '@/types/subscriberLead';

const SUBSCRIBER_LEADS_COLLECTION = 'subscriberLeads';

const firestoreDb: typeof db = db;

export const subscriberLeadsService = {
  async create(email: string, source: SubscriberLeadSource): Promise<void> {
    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) {
      throw new Error('Email is required');
    }

    await addDoc(collection(firestoreDb, SUBSCRIBER_LEADS_COLLECTION), {
      email: normalizedEmail,
      source,
      createdAt: Timestamp.now(),
    });
  },

  async getAll(): Promise<SubscriberLead[]> {
    const q = query(
      collection(firestoreDb, SUBSCRIBER_LEADS_COLLECTION),
      orderBy('createdAt', 'desc')
    );
    const snapshot = await getDocs(q);

    return snapshot.docs.map((item) => ({
      id: item.id,
      ...item.data(),
      createdAt: item.data().createdAt?.toDate(),
    })) as SubscriberLead[];
  },

  async delete(id: string): Promise<void> {
    await deleteDoc(doc(firestoreDb, SUBSCRIBER_LEADS_COLLECTION, id));
  },
};
